module.exports = __webpack_public_path__ + "static/media/logo_1.ed9e24d3.png";